import { all } from '@redux-saga/core/effects';
import userSaga from '../modules/user/saga';

export default function* rootSaga () : Generator {
  yield all([
    ...userSaga,
  ]);
}